import React from 'react';

const NextIcon = () => {
  return <img src='/skill-icons/next.png' alt='next-logo' />;
};

export default NextIcon;
